import * as React from 'react';

import { SVGProps } from './type';

const CheckboxCheckedSVG = (props: SVGProps) => {
  const { width = 15, height = 12, color = '#FFF' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.167 6.833 5.333 11l8.334-10"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckboxCheckedSVG;
